export default __webpack_public_path__ + "static/media/james2.3518bb0d.png";